export const staircaseConfig = {
    gameSlug: 'face-to-face',
    category: 'lumiere_emotions',
    variable: 'duration_ms',
    startValue: 1500,
    minValue: 100,
    maxValue: 2500,
    stepSizesByPhase: [200, 100, 50, 25],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 24,
    direction: 'down-easier',
};
export const EMOTIONS = [
    'joie',
    'tristesse',
    'colere',
    'peur',
    'degout',
    'surprise',
    'neutre',
];
export const EMOTION_EMOJI = {
    joie: '😄',
    tristesse: '😢',
    colere: '😠',
    peur: '😨',
    degout: '🤢',
    surprise: '😲',
    neutre: '😐',
};
export const EMOTION_LABEL = {
    joie: 'Joie',
    tristesse: 'Tristesse',
    colere: 'Colère',
    peur: 'Peur',
    degout: 'Dégoût',
    surprise: 'Surprise',
    neutre: 'Neutre',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, nCandidates: 4, includeNeutral: false, label: 'Macro-émotions' };
    }
    if (level <= 20) {
        return { level, nCandidates: 5, includeNeutral: false, label: 'Speed' };
    }
    if (level <= 30) {
        return { level, nCandidates: 6, includeNeutral: true, label: 'Micro + neutre' };
    }
    if (level <= 40) {
        return { level, nCandidates: 7, includeNeutral: true, label: 'Émotions complexes' };
    }
    return { level, nCandidates: 7, includeNeutral: true, label: 'Lecture rapide' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 400,
    maskMs: 200,
    feedbackMs: 700,
    itiMs: 800,
    minRenderMs: 100,
};
export const paradigmMeta = {
    slug: 'face-to-face',
    paradigm: 'Facial emotion recognition (FERT — Ekman & Friesen 1976)',
    masterMage: 'Sole (lumière) + Inori (perception)',
    category: 'lumiere_emotions',
    goal: 'Reconnaissance émotion faciale — relations, alexithymie, sensibilité sociale.',
};
//# sourceMappingURL=params.js.map